import { v4 } from 'uuid';
import { SEVERITIES } from '../constants';
import t from '../translate';

export const VERY_GOOD = {
  id: v4(),
  title: t('score_on_me.very_good'),
  color: 'var(--limeGreen)',
  range: { min: 91, max: 100 },
  description: '',
  shortValue: 'A',
  severities: [
    { values: [SEVERITIES.MEDIUM], text: t(`score_on_me.severities.medium`) },
    { values: [SEVERITIES.LOW], text: t(`score_on_me.severities.low_info`) }
  ]
};
export const GOOD = {
  id: v4(),
  title: t('score_on_me.good'),
  color: 'var(--uscGold)',
  range: { min: 81, max: 90 },
  description: '',
  shortValue: 'B',
  severities: [
    { values: [SEVERITIES.HIGH], text: t(`score_on_me.severities.high`) },
    { values: [SEVERITIES.MEDIUM], text: t(`score_on_me.severities.medium`) },
    { values: [SEVERITIES.LOW], text: t(`score_on_me.severities.low_info`) }
  ]
};
export const MODERATE = {
  id: v4(),
  title: t('score_on_me.moderate'),
  color: 'var(--heatWave)',
  range: { min: 71, max: 80 },
  description: '',
  shortValue: 'C',
  severities: [
    { values: [SEVERITIES.VERY_HIGH], text: t(`score_on_me.severities.very_high`) },
    { values: [SEVERITIES.HIGH], text: t(`score_on_me.severities.high`) },
    { values: [SEVERITIES.MEDIUM], text: t(`score_on_me.severities.medium_low_info`) }
  ]
};
export const POOR = {
  id: v4(),
  title: t('score_on_me.poor'),
  color: 'var(--lust)',
  range: { min: 61, max: 70 },
  description: '',
  shortValue: 'D',
  severities: [
    { values: [SEVERITIES.VERY_HIGH], text: t(`score_on_me.severities.very_high`) },
    { values: [SEVERITIES.HIGH], text: t(`score_on_me.severities.high`) },
    { values: [SEVERITIES.MEDIUM], text: t(`score_on_me.severities.medium_low_info`) }
  ]
};
export const VERY_POOR = {
  id: v4(),
  title: t('score_on_me.very_poor'),
  color: 'var(--infraredBurn)',
  range: { min: 51, max: 60 },
  description: '',
  shortValue: 'F',
  severities: [
    { values: [SEVERITIES.VERY_HIGH], text: t(`score_on_me.severities.very_high`) },
    { values: [SEVERITIES.HIGH], text: t(`score_on_me.severities.high`) },
    { values: [SEVERITIES.MEDIUM], text: t(`score_on_me.severities.medium_low_info`) }
  ]
};
export const DEFAULT = {
  title: '',
  color: 'var(--platinum)',
  severities: [],
  range: { min: 0, max: 0 },
  description: '',
  shortValue: 'A'
};

export const getStatusObjectByScore = (score = 0) => {
  if (score >= 91 && score <= 100) {
    return VERY_GOOD;
  }
  if (score >= 81 && score <= 90) {
    return GOOD;
  }
  if (score >= 71 && score <= 80) {
    return MODERATE;
  }
  if (score >= 61 && score <= 70) {
    return POOR;
  }
  if (score >= 51 && score <= 60) {
    return VERY_POOR;
  }
  return DEFAULT;
};
